var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-container"},[_c('div',{staticClass:"base-body"},[_vm._t("content")],2),_c('div',{staticClass:"base-footer"},[_c('DygcFooter',{staticClass:"mt-2 -mb-2"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }